import { refs, booleanDataset, dispatchEvent } from '../modules/utils.js';

class NavOverlay extends HTMLElement {
  static get observedAttributes() {
    return ['data-display'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-display') {
      const display = newValue === '' ? true : false;
      dispatchEvent('navoverlay:display', { value: display });
      booleanDataset(document.documentElement, 'unscrollable', display);
    }
  }

  async connectedCallback() {
    await new Promise(resolve => setTimeout(resolve, 0));
    this.refs = refs(this);
    this.#listeners();

    // setTimeout(() => {
    //   booleanDataset(this, 'display', true);
    // });
  }

  #listeners() {
    document.addEventListener('topbar:menu', () => {
      booleanDataset(this, 'display', this.dataset.hasOwnProperty('display') ? false : true);
    });

    this.refs.close?.addEventListener('click', () => {
      booleanDataset(this, 'display', false);
    });


    this.refs.navItems?.forEach((el, i) => {
      el.addEventListener('mouseenter', () => {
        this.refs.navItems.forEach((ell, i) => {
          if (ell !== el) {
            booleanDataset(ell, 'blur', true);
          }
        });
      });
      el.addEventListener('mouseleave', () => {
        this.refs.navItems.forEach((ell, i) => {
          booleanDataset(ell, 'blur', false);
        });
      });
    });
  }
}

customElements.define('nav-overlay', NavOverlay);
